module.exports = __webpack_public_path__ + "media/images/logo_r-062295e91025e76b61be35102ba97ed2.png";